import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { IVListRow } from "@directives/_veri/v-list/v-list.component";
import { IZone, IZoneWithProbes } from "@temperature/_models/temperature/ITemperatureZone";
import { IVehicle } from "@interfaces/IVehicle";
import './temperature-zones-edit.component.scss';
import { ZoneService } from "@temperature/_services/zone.service";
import { ZoneStatus } from "@temperature/_enums/temperature/ZoneStatus.enum";
import { ZoneCreationSource } from "@temperature/_enums/temperature/ZoneCreationSource.enum";
import { VehicleService } from "@services/vehicle.service";
import { lastValueFrom } from "rxjs";

@Component({
    template: require("./temperature-zones-edit.component.html"),
    selector: 'temperature-zones-edit'
})
export class TemperatureZonesComponent implements OnInit {

    loading = false;

    resolutionCodeText: string;
    editMode = false;


    @Input() zones: IZoneWithProbes[];

    @Input() vehicle: IVehicle;

    zoneList: IVListRow<IZoneWithProbes>[];

    selectedZone: IZoneWithProbes;


    constructor(

        private readonly zoneService: ZoneService,
        private readonly vehicleService: VehicleService,
    ) {

    }

    ngOnInit(): void {
        this.prepareList();
    }


    addOrUpdateZone() {
        this.loading = true;
        lastValueFrom(this.zoneService.saveTemperatureZone(this.selectedZone)).then(zone => {
            lastValueFrom(this.zoneService.getZones({ VehicleId: this.vehicle.Id, Status: ZoneStatus.Active,  invalidateCache: false })).then(zones => {
                this.zones = zones;
                this.zoneService.mapProbesToZone(this.zones, this.vehicle.probes);
                this.prepareList();

                this.loading = false;
            })
        })
    }

    listItemSelected(listItem: IVListRow<IZoneWithProbes>) {
        this.selectedZone = listItem.data;
        this.resolutionCodeText = listItem.data.Name;
        this.editMode = true;
    }

    cancelEditMode() {
        this.editMode = false;
        this.selectedZone = {
            Id: null,
            Name: '',
            VehicleId: this.vehicle.Id,
            Position: null,
            CreatedTime: null,
            UpdatedTime: null,
            Status: ZoneStatus.Active,
            Source: ZoneCreationSource.User
        }
    }

    deactivateZone(confirmation: boolean) {
        if (!confirmation) {
            return;
        }
        this.selectedZone.Status = ZoneStatus.Inactive;

        let promises: angular.IPromise<any>[] = [];

        this.vehicle.probes.forEach(probe => {

            if (probe.ZoneId == this.selectedZone.Id) {
                probe.ZoneId = null;
                probe.ZonePosition = null;
            }
            promises.push(this.vehicleService.updateVehicleProbe(probe, true));
        });

        Promise.all(promises)
            .then(() => {
                this.addOrUpdateZone();
            })
            .finally(() => {
                this.loading = false;
            });

    }

    private prepareList() {

        this.selectedZone = {
            Id: null,
            Name: '',
            VehicleId: this.vehicle.Id,
            Position: null,
            CreatedTime: null,
            UpdatedTime: null,
            Status: ZoneStatus.Active,
            Source: ZoneCreationSource.User
        }

        this.zoneList = [];

        this.zones.forEach(zone => {

            zone.Name = zone.Name ?? "Zone " + zone.Position;

            this.zoneList.push({
                data: zone,
                id: zone.Id,
                searchString: zone.Name ,
                sortData: zone.Name,
                contents: zone.Name

              })

        })

    }



}
